import { FC, Fragment, JSX } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import { AddRounded as AddRoundedIcon } from '@mui/icons-material';
// components
import BaseCoatingTable from './BaseCoatingTable';
// constant, styles, reducer, graphql
import { flexCenterBetween } from 'styles/commonComponentStyle';
import { ADD_NEW_TEXT, ADD_BASE_COATING_ROUTE, BASE_COATING_TEXT } from 'constants/index';

const BaseCoating: FC = (): JSX.Element => {
  const navigate = useNavigate();

  return (
    <Fragment>
      <Box sx={flexCenterBetween}>
        <Typography variant="h5">{BASE_COATING_TEXT}</Typography>
        <Button variant="contained" color="primary" onClick={() => navigate(ADD_BASE_COATING_ROUTE)}>
          <AddRoundedIcon />
          {ADD_NEW_TEXT}
        </Button>
      </Box>
      <BaseCoatingTable />
    </Fragment>
  );
};

export default BaseCoating;
